/**
 * The dropdown picker overlay displayed when an emulated dropdown is focused.
 */


import anchored from '../private/anchored'


export default {
    name: 'ib-dropdown-pick',
    mixins: [anchored],

    props: {
        owner: Object,
        value: [String, Number, Boolean],
        filter: String,
        _style: Object
    },

    data() {
        return {
            focus: null,
            last: null,
            list: null
        };
    },

    render(createElement) {
        return createElement('div', {
            'class': {
                _mdls: true,
                _con: true,
                _d2: true,
                _v: this.visible && !this.occluded,
                ['_p'+this.actual]: true,
                ['_a'+this.align]: true
            },
            attrs: {
                dir: this.$root.__app?.direction || 'ltr'
            }
        }, [
            createElement('div', {
                ref: 'content',
                'class': {
                    _mdlsdef: true,
                    _ddo: true
                },
                on: {
                    mouseover: this._mouseover,
                    mouseup: this._mouseup,
                    mousedown: this._mousedown
                }
            })
        ]);
    },

    methods: {
        onOpen() {
            // Clone list inside popup
            this.list = this.owner.$refs.ul.cloneNode(true);
            this.last = this.owner.selectedOptions;
            Object.assign(this.$el.style, this._style);
            this.$refs.content.appendChild(this.list);
            this.owner.expanded = true;
            if (!this.focus) {
                const index = [].indexOf.call(this.owner.$refs.ul.children, this.last[this.last.length-1]);
                if (index >= 0) {
                    this.setFocus(this.list.children[index]);
                }
            }
            if (!this.focus || this.owner.multiple) {
                this.move('nextElementSibling', 1);
            }
        },

        onClose() {
            // Swap placeholder and actual list
            this.$refs.content.replaceChildren();
            this.owner.expanded = false;
            if (this.focus) {
                this.focus.classList.remove('_foc');
                this.focus = null;
            }
            if (this.filter) {
                this.setFilter(null);
            }
            this.list = null;
        },

        /** @private */
        _mouseover(e) {
            let target = e.target;
            while (target.getAttribute('role') != 'option') {
                target = target.parentElement;
                if (!target || target === this.$el) {
                    return false;
                }
            }
            this.setFocus(target);
            return true;
        },

        /** @private */
        _mouseup(e) {
            if (this._mouseover(e)) {
                this.select();
            }
        },

        /** @private */
        _mousedown(e) {
            e.preventDefault();
        },

        setFilter(filter) {
            if (this.list) {
                let li = this.list.firstChild;
                if (filter) {
                    const re = RegExp(filter.replace(/[\\^$.|?*+()[{]/g, '\\$&').replace(/\s+/g, '.+'), 'i');
                    while (li) {
                        li.style.display = re.test(li.textContent) ? null : 'none';
                        li = li.nextSibling;
                    }
                } else {
                    while (li) {
                        li.style.display = null;
                        li = li.nextSibling;
                    }
                }
                if (this.focus && this.focus.style.display == 'none') {
                    this.focus.classList.remove('_foc');
                    this.focus = null;
                    this.move('nextElementSibling', 1);
                }
            }
        },

        setFocus(target) {
            if (this.focus !== target) {
                if (this.focus) {
                    this.focus.classList.remove('_foc');
                }
                this.focus = target;
                if (target) {
                    target.classList.add('_foc');
                    this.$util.scrollIntoView(this.focus, this.$refs.content, this.$el);
                }
            }
        },

        move(direction, cnt) {
            let next, li = this.focus;
            let n = cnt;
            do {
                next = li ? li[direction] : this.list.firstChild;
                if (next || n == cnt) {
                    li = next;
                }
            } while (next && (li.getAttribute('role') != 'option' || li.style.display == 'none' || li.getAttribute('aria-disabled') || --n));
            if (li) {
                this.setFocus(li);
            }
            return li;
        },

        key(code) {
            const owner = this.owner;
            switch (code) {
            case 13:  // Enter
                this.select();
                if (owner.multiple && !this.move('nextElementSibling', 1)) {
                    this.focus = null;
                    this.move('nextElementSibling', 1) || this.close();
                }
                break;
            case 27:  // Escape
                if (owner.filtered) {
                    owner.selectedOptions = this.last;
                    owner.syncEmu();
                }
                this.close();
                break;
            case 33:  // PageUp
                this.move('previousElementSibling', 10);
                break;
            case 34:  // PageDown
                this.move('nextElementSibling', 10);
                break;
            case 38:  // Up
                this.move('previousElementSibling', 1);
                break;
            case 40:  // Down
                this.move('nextElementSibling', 1);
                break;
            }
        },

        select() {
            const owner = this.owner;
            if (owner && this.focus && !this.focus.getAttribute('aria-disabled')) {
                if (owner.multiple) {
                    owner.selectedOptions.push(this.focus);
                    this.$nextTick(this.refresh);
                } else {
                    owner.selectedOptions = [this.focus];
                    this.close();
                }
                owner._change();
            }
        }
    }
};
